import React, { useContext } from "react";
import OrderContext from "../../../../context/OrderContext";
import ReactPaginate from "react-paginate";

const OrderPagination = () => {
  let { totalItems, limit, setPage, searchParams, setSearchParams } =
    useContext(OrderContext);

  function handlePageClick(event) {
    setPage((old) => event.selected + 1);
    searchParams.set("page", event.selected + 1);
    setSearchParams(searchParams.toString());
  }

  console.log(totalItems);

  return (
    <>
      <ReactPaginate
        breakLabel="..."
        nextLabel=" "
        onPageChange={handlePageClick}
        pageCount={totalItems / limit}
        previousLabel=""
        selectedPageRel="a"
        renderOnZeroPageCount={null}
        containerClassName="pagi"
        pageClassName="pagi-item"
        activeClassName="active"
        activeLinkClassName="asd"
        nextClassName="next feather icon-chevron-right"
        previousClassName="prev feather icon-chevron-left"
        forcePage={searchParams.get("page") ? searchParams.get("page") - 1 : 0}
      />
    </>
  );
};

export default OrderPagination;
